{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-bitbucket-oauth-ui",
  "version": "6.0.8",
  "keywords": [
    "authentication",
    "github",
    "bitbucket",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build:all": "yarn clean && yarn install && yarn build && yarn pack",
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format": "prettier --write '{src,test}/**/*.{ts,js,css,scss,html,json}'",
    "format:check": "prettier --check '{src,test}/**/*.{ts,js,css,scss,html,json}'",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^4.1.0",
    "@octokit/request": "^8.4.0",
    "@verdaccio/url": "^11.0.0-6-next.42",
    "axios": "^1.7.2",
    "dotenv": "^16.4.5",
    "express": "^4.19.2",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.21",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.8",
    "octokit": "^3.2.1",
    "open": "^8.4.2",
    "ow": "^0.28.2",
    "picocolors": "^1.0.1",
    "query-string": "^7.1.3"
  },
  "devDependencies": {
    "@parcel/config-default": "~2.4.1",
    "@parcel/transformer-typescript-tsc": "~2.4.1",
    "@types/express": "^4.17.21",
    "@types/global-agent": "^2.1.3",
    "@types/lodash": "^4.17.4",
    "@types/memory-cache": "^0.2.5",
    "@types/minimist": "^1.2.5",
    "@types/node": "^20.12.12",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^10.8.0",
    "@vitest/coverage-v8": "^1.6.0",
    "browserslist": "^4.23.0",
    "core-js": "^3.37.1",
    "nodemon": "^3.1.0",
    "parcel": "~2.4.1",
    "prettier": "^3.2.5",
    "process": "^0.11.10",
    "release-it": "^16.3.0",
    "timekeeper": "^2.3.1",
    "type-fest": "^4.18.2",
    "typescript": "^5.4.5",
    "verdaccio": "~5.30.3",
    "verdaccio-htpasswd": "^10.5.5",
    "vitest": "^1.6.0"
  },
  "peerDependencies": {
    "verdaccio": ">=5"
  },
  "packageManager": "yarn@3.2.1",
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-5.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
